(function () {
    'use strict';

    var controller = function ($timeout) {
        var ctrl = this;
        var _init = false;

        ctrl.tick = tios.util.getSymbol('tick');

        ctrl.$onInit = init;
        ctrl.$onChanges = change;

        //-
        function setCheck(index, value) {
            ctrl.boxes[index].checked = !ctrl.boxes[index].checked;
            ctrl.modelCtrl.$setViewValue(value, 'checklist.js::setCheck');

            if (typeof ctrl.onCheck === 'function') ctrl.onCheck({ $event: { value: value } });
        }

        function setModel(index) {
            var label = ctrl.boxes[index].label;
            var value = ctrl.boxes[index].value;

            if (!ctrl.boxes[index].lock) {
                if (!!ctrl.isFlags) {
                    var modelVal = ctrl.modelCtrl.$viewValue;
                    if ((modelVal & value) === value) {
                        ctrl.boxes[index].checked = false;
                        modelVal -= value;
                    } else {
                        ctrl.boxes[index].checked = true;
                        modelVal += value;
                        ctrl.boxes[index].lock = ctrl.lockCheck;
                    }
                    ctrl.modelCtrl.$setViewValue(modelVal, 'checklist.js::catchCheck');
                    if (typeof ctrl.onCheck === 'function') ctrl.onCheck({ $event: { flag: value } });
                } else {
                    if (!ctrl.radio) {
                        if (ctrl.modelCtrl.$viewValue === ctrl.boxes[index].value) {
                            if (!!index) {
                                label = ctrl.boxes[index - 1].label;
                                value = ctrl.boxes[index - 1].value;
                            } else {
                                label = value = null;
                            }
                        } else {
                            ctrl.boxes[index].lock = ctrl.lockCheck;
                        }
                    } else {
                        for (var bx = 0; bx < ctrl.boxes.length; bx++) {
                            if (bx !== index) {
                                ctrl.boxes[bx].checked = false;
                            }
                        }

                        if (ctrl.modelCtrl.$viewValue === ctrl.boxes[index].value) value = null;
                    }

                    setCheck(index, value);
                }
            }
        };

        ctrl.catchCheck = function (index) {
            if (!ctrl.disabled) {
                var label = ctrl.boxes[index].label;
                if (!!ctrl.confirmLabel || !!ctrl.confirmString) {
                    global.showConfirm({
                        title: 'Confirm',
                        message: !!label ?
                            (!!ctrl.confirmString ?
                                (ctrl.confirmString + ' ' + label + '?') :
                                `Are you sure you want to set ${ctrl.confirmLabel} to ${label}?`) :
                            `Are you sure you want to unset ${ctrl.confirmLabel}`,
                        ok: 'Yes',
                        cancel: 'No',
                        callback: function (ok) {
                            if (ok) setModel(index);
                        }
                    });
                } else {
                    setModel(index);
                }
            }
        };

        function checkModel() {
            if (!!ctrl.isFlags) {
                for (var box of ctrl.boxes) {
                    box.checked = ((ctrl.modelCtrl.$viewValue & box.value) === box.value);
                    box.lock = box.checked && ctrl.lockCheck;
                }
            } else {
                var index = ctrl.boxes.findIndex(fi => fi.value === ctrl.modelCtrl.$viewValue);
                if (index > -1) {
                    if (!ctrl.radio) {
                        while (index > 0) {
                            ctrl.boxes[index].checked = true;
                            index--;
                        }
                    } else {
                        ctrl.boxes[index].checked = true;
                    }
                }
            }
        }

        //Alias methods
        function change(changes) {
            if (_init) {
            }
        }

        function init() {
            $timeout(function () {
                if (!!ctrl.enumBoxes) {// Create box list using enum values
                    ctrl.boxes = ctrl.enumBoxes.map(function (eb) {
                        return {
                            label: (!!ctrl.useName ? eb.Name : eb.Description),
                            value: (!!ctrl.valueName ? eb.Name : eb.Value),
                        };
                    });
                }

                if (ctrl.modelCtrl.$viewValue) checkModel();

                _init = true;
            });
        };
    };
    // Using app.register.component so it can be lazy loaded
    app.component('checklist', {
        require: {
            modelCtrl: 'ngModel',
            //checkbox: '^^checkbox'//TODO revisit
        },
        bindings: {
            boxes: '<?',
            enumBoxes: '<?',

            useName: '<?',
            valueName: '<?',
            isFlags: '<?',

            radio: '<?',

            confirmLabel: '@?',
            confirmString: '@?',

            lockCheck: '<?',// Disallow unsetting of checks

            disabled: '<?',

            onCheck: '&?',
        },

        controller: ['$timeout', controller],

        /*template: '<checkbox ng-repeat="check in $ctrl.boxes track by $index" ng-model="check.checked" data-label="check.label" data-on-check="$ctrl.catchCheck($index)"></checkbox>'*/
        template: '<div ng-repeat="box in $ctrl.boxes track by $index" ng-click="$ctrl.catchCheck($index)" ng-class="{ \'is-checked\': box.checked, \'disabled\':!!$ctrl.disabled,  \'no-click\': (!$ctrl.isFlags && !$last && !!$ctrl.boxes[$index + 1].checked) || box.lock }"><span class="label" ng-bind="box.label"></span><span class="box"><svg ng-show="box.checked"><use xlink:href="" ng-href="{{::$ctrl.tick}}" /></svg></span></div>'
    });
})();